import useTranslation from 'next-translate/useTranslation'
import { LayoutContext } from '../components/sg/Layout'
import { useContext } from 'react'

export default function useCopy () {
  // eslint-disable-next-line no-unused-vars
  const [layoutContext, setLayoutContext] = useContext(LayoutContext)
  const { t } = useTranslation('main')

  return elem => {
    setLayoutContext({ success: '' })

    const el = document.createElement('textarea')
    const sourceEl = document.getElementById(elem)
    const text = sourceEl?.value || elem
    el.value = text
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)

    setLayoutContext({ success: t('copy-textcopied') + ': "' + text + '"' })
  }
}
